var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "tile h-100 mb-2" }, [
    _c("div", { staticClass: "container h-100 mw-100 border-2 bg-dark" }, [
      _c("div", { staticClass: "row h-100" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column px-0 h-100 w-100 bg-header-tile align-items-stretch",
          },
          [
            _c("div", { staticClass: "flex-grow-1" }, [
              _c(
                "div",
                {
                  staticClass:
                    "h-100 d-flex flex-column justify-content-center align-content-center text-center px-1",
                },
                [
                  _c("div", { staticClass: "mt-0 mx-auto" }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-center text-white title-align pt-1",
                        staticStyle: { "font-size": "3rem" },
                      },
                      [
                        _c("span", {
                          staticClass: "text-primary",
                          class: _vm.attributesTile.icon,
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.attributesTile.attributes, function (attribute) {
                    return _c("div", { staticClass: "row bg-dark p-1" }, [
                      _c("div", { staticClass: "col-12 bg-header-tile" }, [
                        _c("span", {
                          staticClass: "h4 text-center text-white",
                          domProps: {
                            innerHTML: _vm._s(attribute.description),
                          },
                        }),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.attributesTile.linkUrl != null
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row bg-dark d-flex justify-content-center pb-1",
                        },
                        [
                          _c("div", { staticClass: "col-12" }, [
                            _c("a", {
                              staticClass:
                                "btn btn-secondary btn-inverse border-white w-100",
                              attrs: {
                                target: "_self",
                                href: _vm.attributesTile.linkUrl,
                                "data-oevent-category": "attribut_offre",
                                "data-oevent-action": "s_identifier",
                                "data-oevent-label": _vm.attributesTile.linkUrl,
                              },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.attributesTile.linkLabel
                                ),
                              },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.attributesTile.popin != null
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row bg-dark d-flex justify-content-center alert-content pb-1",
                        },
                        [
                          _c("div", { staticClass: "col-12" }, [
                            _c("a", {
                              staticClass: "ob1-link-arrow ob1-link-reverse",
                              attrs: {
                                target: "_self",
                                href:
                                  "#" +
                                  _vm.attributesTile.popin.crossDiscountPopin
                                    .modal.id,
                                "data-bs-toggle": "modal",
                                "data-oevent-category": "ouverture_popin",
                                "data-oevent-label": "attributs_offre",
                                "data-oevent-action": "remise-popin",
                              },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.attributesTile.popin.popinLinkLabel
                                ),
                              },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }